import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NotificationService } from 'src/app/Service/notification.service';
import { OrganizationService } from 'src/app/Service/organization/organization.service';
import { IOrganizationViewModel } from 'src/app/ViewModel/OrganizationModel';
import { EditOrganizationComponent } from '../dialogs/organization-dialog/edit-organization-dialog.component';
import * as moment from 'moment';


@Component({
  selector: 'app-organization',
  templateUrl: './organization.component.html',
  styleUrls: ['./organization.component.css']
})
export class OrganizationComponent implements OnInit {
  enableFilter = false;
  enableFullscreen = false;
  masterShow = true;
  hoverClass = '';
  IsShowSection = false;
  configurationShow = false;
  public pageSize = [50, 100, 200, {
    text: 'All',
    value: 'all'
  }];
  /**Organization array */
  public orgList: IOrganizationViewModel[] = [];

  constructor(private _orgService: OrganizationService, private _dialog: MatDialog, private _notificationService: NotificationService) { }

  ngOnInit() {
    this.getOrganizationList();
  }
  /**
   * Get organization list
   */
  getOrganizationList() {
    this._orgService.getOrganizationList().subscribe((data: IOrganizationViewModel[]) => {
      this.orgList = data.map(x => {
        let result: IOrganizationViewModel = {
          group_Id: x.group_Id, group_Code: x.group_Code, group_Name: x.group_Name, group_Short_Name: x.group_Short_Name,
          group_Head_Id: x.group_Head_Id, group_Logo_URL: x.group_Logo_URL, is_Active: x.is_Active, user_Id: x.user_Id,
          created_By: x.created_By,
          created_On: x.created_On,
          modified_By: x.modified_By,
          modified_On: x.modified_On
        };
        return result;
      });
    });
  }

  /**
   * Add/Update Organization 
   * @param organization Organization model 
   */
  addEditOrganization(organization: any | IOrganizationViewModel) {
    if (organization === undefined)
      organization = null;
    const dialogRef = this._dialog.open(EditOrganizationComponent, {
      panelClass: 'mat-dialog-secondary',
      width: '95%',
      minWidth: '95vw',
      data: organization
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      let resOrganization: IOrganizationViewModel = res.organization;
      if (res.response && res.response.successCode == 200 && resOrganization) {
        let filteredOrg: IOrganizationViewModel = this.orgList.filter(x => x.group_Id == resOrganization.group_Id)[0];
        if (filteredOrg) {
          filteredOrg.group_Short_Name = resOrganization.group_Short_Name;
          filteredOrg.group_Name = resOrganization.group_Name;
          filteredOrg.is_Active = resOrganization.is_Active;
          filteredOrg.group_Logo_URL = resOrganization.group_Logo_URL;
          filteredOrg.group_Code = resOrganization.group_Code;
        } else {
          this.orgList = [...this.orgList, ...[resOrganization]];
        }
        this._notificationService.showToast(res.response.successMessage, "Success");
        this.getOrganizationList();
      }
      else if (res.response.successCode == 205) {
        this._notificationService.showToast(res.response.successMessage, "Warning");
      }
    }, err => { });
  }
  /**
   * Toggle filter
   */
  toggleFilter() {
    this.enableFilter = !this.enableFilter;
  }

  /**
     * Full screen
     */
  toggleFullscreen() {
    this.enableFullscreen = !this.enableFullscreen;
  }

  onHoverTrigger(e) {
    this.hoverClass = 'open';
    this.IsShowSection = !this.IsShowSection;
  }
}
